module.exports = new __parcel__URL__("stained-glass-3.e12caf5c.webp").toString();